import { render, staticRenderFns } from "./ImsModalCard.vue?vue&type=template&id=65f9c9de"
import script from "./ImsModalCard.vue?vue&type=script&lang=js"
export * from "./ImsModalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports